import { View } from "react-native"
import MIcon from "@react-native-vector-icons/material-design-icons"

import { ENV } from "@src/utils"

import { Text } from "./core"
import appJson from "../app.json"

const runtimeVersion = Number.parseInt(appJson.expo.runtimeVersion, 10)
export function MaintenanceScreen() {
  return (
    <View className="flex-1 items-center bg-white justify-center px-4">
      <View className="items-center">
        <View className="bg-blue-50 p-6 rounded-full mb-6">
          <MIcon name="wrench" size={64} color="#2563EB" />
        </View>

        <Text className="text-3xl font-bold text-center text-gray-900 mb-4">تحت الصيانة</Text>

        <Text className="text-lg text-gray-600 leading-relaxed max-w-md text-center">
          نقوم حالياً بتحسين خدماتنا لتقديم تجربة أفضل. يرجى المحاولة مرة أخرى لاحقاً.
        </Text>
        <Text>
          {runtimeVersion} / {appJson.expo.version} / {ENV.channel}
        </Text>
      </View>
    </View>
  )
}
